var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
export var InnerHtml = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var text = useRef(null);
    useEffect(function () {
        if (text.current) {
            for (var i = 0; i < text.current.children.length; i++) {
                var item = text.current.children[i];
                if (item.tagName === 'A') {
                    if (item.target === '_blank') {
                        item.rel = 'noopener noreferrer';
                    }
                    else {
                        item.target = '_top';
                    }
                }
            }
        }
    }, []);
    return (React.createElement("div", __assign({}, props, { ref: text, dangerouslySetInnerHTML: { __html: children } })));
};
